import { navLinks } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-secondary-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-9 md:grid-cols-12 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-secondary-50">小蓝视频</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-secondary-200">
              小蓝视频官网入口、APP 下载、最新地址与安装包获取路径的专题合集页，并说明在线看的使用方法。
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-label text-xs tracking-[0.2em] text-secondary-300">站内导航</h3>
            <ul className="mt-4 space-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a href={link.href} className="cursor-pointer text-sm text-secondary-100 transition-colors hover:text-accent-300">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-label text-xs tracking-[0.2em] text-secondary-300">使用提醒</h3>
            <ul className="mt-4 space-y-3 text-sm leading-6 text-secondary-200">
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center text-accent-400">
                  <i className="ri-checkbox-circle-line text-sm" />
                </span>
                请以本页渠道作为官方入口与安装包来源
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center text-accent-400">
                  <i className="ri-checkbox-circle-line text-sm" />
                </span>
                如遇入口无法打开，可切换备用线路后重试
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center text-accent-400">
                  <i className="ri-checkbox-circle-line text-sm" />
                </span>
                建议收藏本页，方便获取最新地址
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 小蓝视频 · 本站为信息指引页面，内容仅作展示</p>
          <p className="font-label tracking-wide">GUIDE HUB · ENTRY / DOWNLOAD / ONLINE</p>
        </div>
      </div>
    </footer>
  );
}